import React from 'react';
import { ActiveMethodManageMfa } from '@app/models';
import { useTypedTranslation } from '@app/hooks';
import Icon from '@app/components/Icon/index';

interface IProps {
    activeMethod: ActiveMethodManageMfa;
}

export const Complete: React.SFC<IProps> = ({ activeMethod }) => {
    const { translation } = useTypedTranslation();

    return (
        <>
            <Icon icon='verification2FaSuccessIco' className='manage-mfa-token__icon' />
            <h1>{translation('MFA_VERIFICATION_SUCCESS_TITLE')}</h1>
            <p className='manage-mfa-token__description'>{translation('MFA_VERIFICATION_SUCCESS_DESCRIPTION')}</p>
        </>
    );
};
